export const QUOTES = [
  "Small steps every day.",
  "Progress over perfection.",
  "Stay focused, stay cozy.",
  "Breathing in, I calm body and mind.",
  "Enjoy the present moment.",
  "One thing at a time.",
  "Focus on the journey, not the destination.",
  "Pour yourself a cup of coffee and begin.",
  "Slow down and do your best.",
  "Deep breath in, deep breath out.",
  "Every small effort counts.",
  "Peace is found in this single moment.",
  "Rest when you need to, but don't quit.",
  "Your cozy space, your steady pace.",
  "Cultivate a quiet mind."
];

export const getRandomQuote = (excludeQuote = "") => {
  const filtered = QUOTES.filter(q => q !== excludeQuote);
  const randomIndex = Math.floor(Math.random() * filtered.length);
  return filtered[randomIndex];
};
